// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationMessage_container__1-wsD","actionBtns":"ConfirmationMessage_actionBtns__0LnQU"};